module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("The More the Merrier")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By Sean Michael")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("The Teddy Bear Club")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Too much of a good thing?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When Logan gets the call about newborn triplets in need of a home, he steps up, realizing too late the daunting task he’s taken on. He’d be lost without the men of the Teddy Bear Club—especially Dirk.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Dirk even offers to spend spring break at Logan’s home, helping him and the babies settle in. He loves being a dad, and he wants to help Logan find the same joy. It doesn’t hurt that they enjoy spending time together.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Before they even realize it, they’re settling into a routine… becoming a family.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Falling in love.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But their new bond is about to face the ultimate test. Will they come through and realize that with love, there’s no such thing as enough?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0